import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const HomeContainer = styled.div`
  display: flex;
  background: #ffffff;
  min-height: 100vh;
`;

export const MainContent = styled.main`
  flex: 1;
  background: #f8f9fa;
  width: 100%;
  margin-left: 280px; /* Largura do sidebar */
  
  @media (max-width: 1024px) {
    margin-left: 0;
  }
`;

export const TopBar = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #e8eaed;
  padding: 16px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  position: sticky;
  top: 0;
  z-index: 100;

  @media (max-width: 1024px) {
    padding: 12px 20px;
    gap: 16px;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    gap: 12px;
    flex-wrap: wrap;
  }
`;

export const TopBarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 12px;
    flex: 1;
    min-width: 0;
  }
`;

export const TopBarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const UserInfoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e8eaed;

  @media (max-width: 768px) {
    padding: 8px 12px;
    gap: 12px;
  }
`;

export const UserAvatarLarge = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #4285f4;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }
`;

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const UserName = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #202124;
  line-height: 1;
`;

export const UserEmail = styled.span`
  font-size: 13px;
  color: #5f6368;
  line-height: 1;
`;

export const EditProfileButton = styled.button`
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  color: #5f6368;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;

  &:hover {
    background: #f8f9fa;
    border-color: #4285f4;
    color: #4285f4;
  }

  .material-icons {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    padding: 8px;
    
    span:not(.material-icons) {
      display: none;
    }
  }
`;

export const IconButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #5f6368;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: #f8f9fa;
  }

  .material-icons {
    font-size: 20px;
  }
`;

export const DashboardGrid = styled.div`
  padding: 32px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  max-width: 1600px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    padding: 20px;
    gap: 20px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const HeroCard = styled.div`
  background: #4285f4;
  border-radius: 16px;
  padding: 48px;
  color: #ffffff;
  position: relative;
  overflow: hidden;
  animation: ${fadeIn} 0.6s ease;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -10%;
    width: 400px;
    height: 400px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -30%;
    left: -5%;
    width: 300px;
    height: 300px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
  }

  @media (max-width: 1024px) {
    padding: 36px 28px;
    border-radius: 12px;
    
    &::before,
    &::after {
      display: none;
    }
  }

  @media (max-width: 768px) {
    padding: 24px 20px;
    animation: none;
  }
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 1;
`;

export const HeroTitle = styled.h1`
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 12px 0;
  line-height: 1.2;

  @media (max-width: 1024px) {
    font-size: 30px;
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 8px;
  }
`;

export const HeroSubtitle = styled.p`
  font-size: 18px;
  margin: 0 0 32px 0;
  opacity: 0.95;
  max-width: 600px;
  line-height: 1.5;

  @media (max-width: 1024px) {
    font-size: 16px;
    margin-bottom: 24px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 20px;
  }
`;

export const HeroMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 24px;
  margin-bottom: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 20px;
    margin-bottom: 24px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 20px;
  }
`;

export const MetricItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 1024px) {
    gap: 12px;
  }

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

export const MetricIcon = styled.div`
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    width: 40px;
    height: 40px;
    font-size: 20px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    font-size: 18px;
    border-radius: 8px;
  }
`;

export const MetricValue = styled.div`
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 4px;

  @media (max-width: 1024px) {
    font-size: 26px;
  }

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const MetricLabel = styled.div`
  font-size: 13px;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 11px;
  }
`;

export const HeroActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

export const PrimaryButton = styled.button`
  padding: 14px 32px;
  background: #ffffff;
  color: #4285f4;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .material-icons {
    font-size: 20px;
  }

  @media (max-width: 1024px) {
    padding: 12px 24px;
    font-size: 14px;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 13px;
    
    &:hover {
      transform: none;
    }
  }
`;

export const SecondaryButton = styled.button`
  padding: 14px 32px;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  backdrop-filter: blur(10px);

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }

  .material-icons {
    font-size: 20px;
  }

  @media (max-width: 1024px) {
    padding: 12px 24px;
    font-size: 14px;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 13px;
    
    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }
`;

export const QuickStatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  animation: ${slideUp} 0.6s ease 0.1s backwards;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    animation: none;
  }
`;

export const QuickStatCard = styled.div`
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 12px;
  padding: 24px;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
    border-color: #dadce0;
  }

  @media (max-width: 1024px) {
    padding: 20px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    border-radius: 8px;
    
    &:hover {
      transform: none;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
    }
  }
`;

export const StatNumber = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #202124;
  margin-bottom: 8px;
  line-height: 1;

  @media (max-width: 1024px) {
    font-size: 28px;
  }

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 6px;
  }
`;

export const StatText = styled.div`
  font-size: 14px;
  color: #5f6368;
  margin-bottom: 8px;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 6px;
  }
`;

export const StatChange = styled.div<{ $positive?: boolean }>`
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => (props.$positive ? "#34a853" : "#ea4335")};
  display: flex;
  align-items: center;
  gap: 4px;

  .material-icons {
    font-size: 16px;
  }

  @media (max-width: 768px) {
    font-size: 11px;
    
    .material-icons {
      font-size: 14px;
    }
  }
`;

export const MainSection = styled.div`
  animation: ${slideUp} 0.6s ease 0.2s backwards;

  @media (max-width: 768px) {
    animation: none;
  }
`;

export const TimelineActivitySection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  animation: ${slideUp} 0.6s ease 0.3s backwards;

  @media (max-width: 1024px) {
    gap: 20px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    animation: none;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #202124;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const SectionAction = styled.button`
  background: none;
  border: none;
  color: #4285f4;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background: #e8f0fe;
  }

  .material-icons {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 10px;
    
    .material-icons {
      font-size: 16px;
    }
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  animation: ${slideUp} 0.6s ease 0.3s backwards;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
    animation: none;
  }
`;

export const FeatureCard = styled.div`
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 12px;
  padding: 28px;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
    border-color: #dadce0;
  }

  @media (max-width: 1024px) {
    padding: 24px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    padding: 20px;
    border-radius: 8px;
    
    &:hover {
      transform: none;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
  }
`;

export const FeatureIcon = styled.div<{ $color: string }>`
  width: 56px;
  height: 56px;
  background: ${(props) => props.$color};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 28px;
  margin-bottom: 20px;

  .material-icons {
    font-size: 28px;
  }

  @media (max-width: 1024px) {
    width: 48px;
    height: 48px;
    font-size: 24px;
    margin-bottom: 16px;
    
    .material-icons {
      font-size: 24px;
    }
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
    font-size: 22px;
    border-radius: 10px;
    margin-bottom: 14px;
    
    .material-icons {
      font-size: 22px;
    }
  }
`;

export const FeatureTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #202124;
  margin: 0 0 12px 0;

  @media (max-width: 1024px) {
    font-size: 17px;
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 8px;
  }
`;

export const FeatureDescription = styled.p`
  font-size: 14px;
  color: #5f6368;
  line-height: 1.6;
  margin: 0 0 16px 0;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 12px;
  }
`;

export const FeatureLink = styled.a`
  font-size: 14px;
  color: #4285f4;
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s;

  &:hover {
    gap: 8px;
  }

  .material-icons {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    
    .material-icons {
      font-size: 16px;
    }
  }
`;

export const TimelineCard = styled.div`
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 12px;
  padding: 28px;
  animation: ${slideUp} 0.6s ease 0.4s backwards;

  @media (max-width: 1024px) {
    padding: 24px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    padding: 20px;
    border-radius: 8px;
    animation: none;
  }
`;

export const TimelineHeader = styled.div`
  margin-bottom: 24px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const TimelineTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #202124;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 17px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const TimelineList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const TimelineItem = styled.div`
  display: flex;
  gap: 16px;
  position: relative;

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    left: 19px;
    top: 40px;
    bottom: -20px;
    width: 2px;
    background: #e8eaed;
  }

  @media (max-width: 768px) {
    gap: 12px;
    
    &:not(:last-child)::after {
      left: 17px;
      top: 36px;
      bottom: -16px;
    }
  }
`;

export const TimelineDot = styled.div<{ $color: string }>`
  width: 40px;
  height: 40px;
  background: ${(props) => props.$color};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;
  position: relative;
  z-index: 1;

  .material-icons {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    
    .material-icons {
      font-size: 18px;
    }
  }
`;

export const TimelineContent = styled.div`
  flex: 1;
  padding-top: 4px;

  @media (max-width: 768px) {
    padding-top: 2px;
  }
`;

export const TimelineText = styled.p`
  font-size: 14px;
  color: #202124;
  font-weight: 500;
  margin: 0 0 4px 0;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 2px;
  }
`;

export const TimelineDate = styled.span`
  font-size: 13px;
  color: #5f6368;

  @media (max-width: 768px) {
    font-size: 11px;
  }
`;

export const ActivityCard = styled.div`
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 12px;
  padding: 28px;
  animation: ${slideUp} 0.6s ease 0.5s backwards;

  @media (max-width: 1024px) {
    padding: 24px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    padding: 20px;
    border-radius: 8px;
    animation: none;
  }
`;

export const ActivityHeader = styled.div`
  margin-bottom: 24px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const ActivityTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #202124;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 17px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ActivityGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (max-width: 1024px) {
    gap: 12px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const ActivityItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background: #e8eaed;
  }

  @media (max-width: 1024px) {
    padding: 14px;
    gap: 10px;
  }

  @media (max-width: 768px) {
    padding: 12px;
    gap: 10px;
    border-radius: 6px;
  }
`;

export const ActivityIcon = styled.div<{ $color: string }>`
  width: 44px;
  height: 44px;
  background: ${(props) => props.$color};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;

  .material-icons {
    font-size: 22px;
  }

  @media (max-width: 1024px) {
    width: 40px;
    height: 40px;
    
    .material-icons {
      font-size: 20px;
    }
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    
    .material-icons {
      font-size: 18px;
    }
  }
`;

export const ActivityText = styled.div`
  flex: 1;
  min-width: 0;

  p {
    font-size: 14px;
    font-weight: 500;
    color: #202124;
    margin: 0 0 4px 0;
  }

  span {
    font-size: 13px;
    color: #5f6368;
  }

  @media (max-width: 768px) {
    p {
      font-size: 13px;
      margin-bottom: 2px;
    }

    span {
      font-size: 11px;
    }
  }
`;

export const SupportCard = styled.div`
  background: #34a853;
  border-radius: 12px;
  padding: 32px;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 24px;
  animation: ${slideUp} 0.6s ease 0.6s backwards;

  @media (max-width: 1024px) {
    padding: 28px;
    gap: 20px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 24px;
    gap: 16px;
    border-radius: 8px;
    animation: none;
  }
`;

export const SupportIcon = styled.div`
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  flex-shrink: 0;
  backdrop-filter: blur(10px);

  .material-icons {
    font-size: 32px;
  }

  @media (max-width: 1024px) {
    width: 56px;
    height: 56px;
    font-size: 28px;
    
    .material-icons {
      font-size: 28px;
    }
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    font-size: 24px;
    
    .material-icons {
      font-size: 24px;
    }
  }
`;

export const SupportContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SupportTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 8px 0;

  @media (max-width: 1024px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 6px;
  }
`;

export const SupportText = styled.p`
  font-size: 14px;
  margin: 0;
  opacity: 0.95;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const SupportActions = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 1024px) {
    gap: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    gap: 10px;
  }
`;

export const SupportButton = styled.button<{ $variant?: string }>`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  ${(props) =>
    props.$variant === "primary"
      ? `
    background: #ffffff;
    color: #34a853;
    border: none;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  `
      : `
    background: rgba(255, 255, 255, 0.2);
    color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(10px);

    &:hover {
      background: rgba(255, 255, 255, 0.25);
    }
  `}

  .material-icons {
    font-size: 20px;
  }

  @media (max-width: 1024px) {
    padding: 10px 20px;
    font-size: 13px;
    
    .material-icons {
      font-size: 18px;
    }
  }

  @media (max-width: 768px) {
    flex: 1;
    justify-content: center;
    padding: 12px 16px;
    font-size: 13px;
    
    &:hover {
      ${(props) => props.$variant === "primary" ? "transform: none;" : "background: rgba(255, 255, 255, 0.2);"}
    }
  }
`;

export const FloatingWhatsAppButton = styled.button`
  position: fixed;
  bottom: 32px;
  right: 32px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #25d366 0%, #20ba5c 100%);
  border: none;
  color: white;
  font-size: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
  transition: all 0.3s ease;
  z-index: 500;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(37, 211, 102, 0.6);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 1024px) {
    bottom: 24px;
    right: 24px;
  }

  @media (max-width: 768px) {
    bottom: 20px;
    right: 20px;
    width: 56px;
    height: 56px;
    font-size: 26px;
  }
`;
